const botTypes = [
  {
    name: 'Conversation Builder',
    type: 'BotCentral',
    inputType: 'inputField',
    hint: 'This must match an Automation ID from Conversation Builder',
    idLabel: 'Automation ID',
  },
  {
    name: 'Google DialogFlow',
    type: 'DialogFlow',
    inputType: 'dragAndDropField',
    hint: 'This must match the projectId from the Google DialogFlow json credential',
    idLabel: 'projectId',
  },
  {
    name: 'Watson',
    type: 'Watson',
    inputType: 'inputField',
    hint: 'This must match a Workspace ID from Watson',
    idLabel: 'Workspace ID',
  },
];

export default botTypes;
